import React from 'react';
import styled from 'styled-components';

const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(?::[0-5]\d)?$/;
const regex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
const today = new Date();
today.setHours(0, 0, 0, 0);

export default function AdminTimestampWidget(props) {
  const {value, onChange, schema = {}, uiSchema} = props;

  const defaultValue = today.toLocaleString('sv');
  const disabled = props.disabled || props.readOnly || props.readonly;

  return (
    <Wrapper>
      <input
        className={'rev-input ' + (uiSchema['ui:classNames'] ?? '')}
        type="datetime-local"
        disabled={disabled}
        value={
          value ? new Date(value).toLocaleString('sv').replace(' ', 'T') : value
        }
        // onClick={() => {
        //   if (!value) {
        //     onChange(defaultValue);
        //   }
        // }}
        onChange={(e) => {
          const value = e.target.value;
          // input datetime-local format yyyy-MM-DDTHH:mm

          if (regex2.test(value)) {
            let _value = value + ':00+08:00';
            onChange(new Date(_value).getTime());
          } else if (!value) {
            onChange(null);
          }
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > input {
    width: 100%;
    border: 1px solid #d9d9d9;
    min-height: 30px;
    padding: 0px 11px;

    &:hover:not(:disabled) {
      border: solid 1px var(--primaryColor);
    }

    &:focus:not(:disabled) {
      border: solid 1px var(--primaryColor);
      outline: none;
    }
    &:disabled {
      color: rgba(0, 0, 0, 0.25);
      background-color: #f5f5f5;
    }
  }
`;
